module.exports = __webpack_public_path__ + "media/11focuson.0d52556d.mp3";